import React from "react";
import { AdminRoomDetailsCard } from "../../../../components";
const RoomDetails = () => {
  return <AdminRoomDetailsCard />;
};

export default RoomDetails;
